export function isSmithersEnabled(): boolean {
  const mode = import.meta.env.MODE
  // E2E is the isolated mock browser-test mode, not a deployment environment.
  const allowedEnvironment = mode === "development" || mode === "dev" || mode === "qa" || mode === "e2e"

  return allowedEnvironment && import.meta.env.VITE_ENABLE_SMITHERS === "true"
}
